import { Component } from '@theme/component';
import { getWishlistItems, removeWishlistItem } from '@theme/wishlist';
import { formatMoney } from '@theme/money-formatting';

const CHANGE_EVENT = 'wishlist:change';

/**
 * Pinta la lista de productos guardados en la wishlist local, resolviendo
 * cada uno con el endpoint publico /products/{handle}.js (no requiere
 * backend propio ni cuenta de cliente).
 */
export class WishlistPageComponent extends Component {
  requiredRefs = ['list', 'empty'];

  connectedCallback() {
    super.connectedCallback();
    this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
    this.currency = this.dataset.currency || 'EUR';
    this.removeLabel = this.dataset.removeLabel || '';
    this.boundRender = this.render.bind(this);
    document.addEventListener(CHANGE_EVENT, this.boundRender);
    this.render();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CHANGE_EVENT, this.boundRender);
  }

  async render() {
    const items = getWishlistItems();
    const { list, empty } = this.refs;

    if (!items.length) {
      list.replaceChildren();
      empty.hidden = false;
      return;
    }

    empty.hidden = true;

    const products = await Promise.all(
      items.map(async (item) => {
        try {
          const response = await fetch(`/products/${item.handle}.js`);
          if (!response.ok) return null;
          return await response.json();
        } catch {
          return null;
        }
      })
    );

    const fragment = document.createDocumentFragment();

    products.forEach((product, index) => {
      if (!product) return;

      const item = items[index];
      const li = document.createElement('li');
      li.className = 'wishlist-page__item';

      const link = document.createElement('a');
      link.href = product.url;

      const image = product.featured_image || (product.images && product.images[0]) || '';
      if (image) {
        const img = document.createElement('img');
        img.src = image;
        img.loading = 'lazy';
        img.alt = product.title;
        link.append(img);
      }

      const title = document.createElement('span');
      title.className = 'wishlist-page__item-title';
      title.textContent = product.title;
      link.append(title);

      const price = document.createElement('span');
      price.className = 'wishlist-page__item-price';
      price.textContent = formatMoney(product.price, this.moneyFormat, this.currency);
      link.append(price);

      li.append(link);

      if (this.removeLabel) {
        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'wishlist-page__item-remove';
        removeButton.textContent = this.removeLabel;
        removeButton.addEventListener('click', () => removeWishlistItem(item.id));
        li.append(removeButton);
      }

      fragment.append(li);
    });

    list.replaceChildren(fragment);
  }
}

if (!customElements.get('wishlist-page-component')) {
  customElements.define('wishlist-page-component', WishlistPageComponent);
}
